import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "../config";
import { useCart } from "../contexts/CartContext";
import "../styles/Products.css";

const Products = () => {
  const { id } = useParams();
  const [products, setProducts] = useState([]);
  const [categoryName, setCategoryName] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [toastMessage, setToastMessage] = useState("");

  const {
    addToCart,
    getItemQuantity,
    increaseQuantity,
    decreaseQuantity
  } = useCart();

  const showToast = (message) => {
    setToastMessage(message);
    setTimeout(() => setToastMessage(""), 2000);
  };

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/categories/${id}/products`);
        setProducts(response.data.products);
        setCategoryName(response.data.category);
      } catch (err) {
        setError(err.response ? err.response.data.message : err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [id]);

  if (loading) return <div className="loading">Loading...</div>;
  if (error) return <div className="error-message">{error}</div>;

  return (
    <div className="products-page">
      <div className="category-header">
        <Link to="/" className="back-link">
          <i className="fas fa-arrow-left"></i>
        </Link>
        <h1 className="category-title">{categoryName}</h1>
      </div>

      {toastMessage && (
        <div className="toast">
          {toastMessage}
        </div>
      )}
      <div className="product-grid">

        {products.map((product) => {
          const quantity = getItemQuantity(product.id);

          return (
            <div key={product.id} className="product-card">
              {product.image && (
                <img
                  src={`${API_BASE_URL}${product.image}`}
                  alt={product.name}
                  className="product-image"
                />
              )}
              <div className="product-details">
                <h3 className="product-name">{product.name}</h3>
                <p className="product-description">{product.description}</p>
                <p className="product-price">Precio: ${product.price.toFixed(2)}</p>

                {quantity === 0 ? (
                  <button
                    className="add-to-cart-btn"
                    onClick={() => {
                      addToCart({
                        id: product.id,
                        name: product.name,
                        price: product.price,
                        image: product.image,
                      });
                      showToast(`${product.name} agregado al carrito ✅`);
                    }}
                  >
                    Agregar al carrito
                  </button>
                ) : (
                  <div className="quantity-controls">
                    <button
                      onClick={() => {
                        decreaseQuantity(product.id);
                        showToast(`Cantidad de ${product.name} reducida`);
                      }}
                    >
                      -
                    </button>
                    <span className="quantity">{quantity}</span>
                    <button
                      onClick={() => {
                        increaseQuantity(product);
                        showToast(`Agregaste otra unidad de ${product.name} ✅`);
                      }}
                    >
                      +
                    </button>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Products;
